import * as anchor from "@project-serum/anchor";
import { PublicKey } from "@solana/web3.js";
import { ASSOCIATED_TOKEN_PROGRAM_ID, Token, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { Metalairs } from "../../idl";
import { AnchorWallet } from "@solana/wallet-adapter-react";
import getMetadata from "../../utils/getMetadata";
import { EMBER_MINT } from "../../vars";

export default async (provider: anchor.AnchorProvider, program: anchor.Program<Metalairs>, mints: PublicKey[]) => {
    const { wallet } = provider
    const [dragoMint, lairMint] = mints
    const [lairPlayAccount, lairPlayAccountBump] = await anchor.web3.PublicKey.findProgramAddress([lairMint.toBuffer(), wallet.publicKey.toBuffer()], program.programId)
    const [dragoPlayAccount, dragoPlayAccountBump] = await anchor.web3.PublicKey.findProgramAddress([dragoMint.toBuffer(), wallet.publicKey.toBuffer()], program.programId)

    const dragoMetadata = await getMetadata(dragoMint)
    const initializerDragoAta = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, dragoMint, wallet.publicKey)
    const lairPlayAccountDragoAta = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, dragoMint, lairPlayAccount, true)

    return program.methods.lockDrago().accounts({
        initializer: wallet.publicKey,
        lairPlayAccount,
        lairMint,
        dragoPlayAccount,
        dragoMint,
        dragoMetadata,
        lairPlayAccountDragoAta,
        initializerDragoAta
    }).transaction()
}